<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :loading="tabela.carregamento" loading-text="Buscando presentes..." :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">PRESENTES</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="tabela.busca" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoDados = true" tile color="#5b3a4b">
            <v-icon left dark>add_circle</v-icon> Adicionar presente
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum presente encontrado</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.urlImagem`]="{ item }">
        <td>
          <v-img :src="item.urlImagem" width="50px"></v-img>
        </td>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon @click="editarItem(item)">edit</v-icon>
        <v-icon @click="deletarItem(item)">delete</v-icon>
      </template>
      <template v-slot:[`item.preco`]="{ item }">
        <td>R$ {{item.preco}}</td>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <td>
          <v-chip :color="item.status == 'ativo' ? 'success' : 'error'">{{ item.status.toUpperCase() }}</v-chip>
        </td>
      </template>
    </v-data-table>

    <v-dialog persistent v-model="dialogoDados" max-width="800px">
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" lg="6">
                <v-text-field v-model="editedItem.descricao" outlined dense hide-details color="#5b3a4b" label="Nome*"></v-text-field>
              </v-col>
              <v-col cols="12" lg="6">
                <v-text-field v-model="editedItem.detalhes" outlined dense hide-details color="#5b3a4b" label="Detalhes*"></v-text-field>
              </v-col>
              <v-col cols="12" lg="3">
                <v-text-field v-model="editedItem.preco" outlined dense hide-details color="#5b3a4b" label="Preço*" prefix="R$"></v-text-field>
              </v-col>
              <v-col cols="12" lg="3">
                <v-select v-model="editedItem.status" outlined dense hide-details color="#5b3a4b" label="Status*" :items="status"></v-select>
              </v-col>
              <v-col cols="12" lg="6">
                <v-text-field v-model="editedItem.urlImagem" outlined dense hide-details color="#5b3a4b" label="Link da imagem*"></v-text-field>
              </v-col>
              <v-col cols="12" lg="6">
                <v-card>
                  <v-img v-if="editedItem.urlImagem" contain style="text-align: center" :src="editedItem.urlImagem" max-height="200px" max-width="200px"></v-img>
                  <v-alert v-if="!editedItem.urlImagem" type="info" style="margin: 10px">Nenhuma imagem informada</v-alert>
                  <v-divider></v-divider>
                  <v-card-text style="font-size: 17px"><b>Imagem</b></v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="fechar">Fechar</v-btn>
          <v-btn text color="success" @click="salvar">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-actions>
      <v-btn color="#5b3a4b" @click="carregaDados" dark>
        <v-icon left>refresh</v-icon>Atualizar
      </v-btn>
    </v-card-actions>
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      faixas: [],
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'descricao', },
          { text: 'Detalhes', value: 'detalhes', },
          { text: 'Preço', value: 'preco', },
          { text: 'Imagem', value: 'urlImagem' },
          { text: 'Status', value: 'status' },
          { text: 'Ações', value: 'action', align: 'center', sortable: true },
        ],
        carregamento: false,
        conteudo: [],
      },
      status: [
        { text: 'ATIVO', value: 'ativo' },
        { text: 'INATIVO', value: 'inativo' },
      ],
      editedIndex: -1,
      editedItem: {
        descricao: '',
        detalhes: '',
        preco: '',
        status: '',
        urlImagem: '',
        codigo: '',
        empresaId: '',
      },
      defaultEditedItem: {
        descricao: '',
        detalhes: '',
        preco: '',
        status: '',
        urlImagem: '',
        codigo: '',
        empresaId: '',
      },
      dialogoDados: false,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'Adicionar novo presente' : 'Editar presente'
      }
    }),

    mounted() {
      this.carregaDados()
    },

    watch: {
      //
    },

    methods: {
      async carregaDados() {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        await axios.get(baseApiUrl + 'Produtos?filter={"where":{"empresaId":"'+this.companyobj.id+'"}}')
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
          }
          this.tabela.carregamento = false
        })
        .catch(() => {
          var vm = this
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao consultar presentes", "DESCULPE")
        })
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      criarConvidado() {
        this.editedItem = Object.assign({}, this.defaultEditedItem)
        this.dialogoDados = true
      },

      editarItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoDados = true
      },

      async deletarItem(item) {
        var r = confirm('Deseja realmente excluir o presente ' + item.descricao + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(baseApiUrl + 'Produtos/' + item.id)
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          })
        }
      },

      fechar() {
        this.dialogoDados = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultEditedItem)
          this.editedIndex = -1
        }, 300)
      },

      async salvar() {
        this.isLoading = true
        var vm = this;
        if (!this.editedItem.descricao || !this.editedItem.detalhes || !this.editedItem.preco || !this.editedItem.status || !this.editedItem.urlImagem) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos!", "ATENÇÃO")
        } else {
          if (this.editedIndex != -1) {
            await axios.patch(`${baseApiUrl}Produtos/${this.editedItem.id}`, this.editedItem)
            .then(response => {
              if (response.data) {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
                this.carregaDados()
              }
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
            })
          } else {
            this.editedItem.empresaId = this.companyobj.id
            let codigo = ''
            while (this.editedItem.codigo == '') {
              codigo = new Date().getTime().toString()
              await axios.get(baseApiUrl + 'Produtos/count?where={"codigo":"' + codigo + '"}').then(response => {
                if (response.data.count == 0) {
                  this.editedItem.codigo = codigo
                }
              })
            }
            await axios.post(`${baseApiUrl}Produtos/replaceOrCreate`, this.editedItem)
            .then(response => {
              if (response.data != null) {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#0288D1", "Presente cadastrado com sucesso!", "INFORMAÇÃO")
                this.carregaDados()
              }
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao cadastrar presente, tente novamente", "DESCULPE")
            })
          }
          this.fechar()
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>